import { CandidateAttachmentsConfig } from './candidate-attachments.abstract.config';

export const candidateAttachmentsConfig: CandidateAttachmentsConfig = {
  privileges: {
    candidates: {
      resumes: 'web:candiadtes-resumes',
      files: 'web:candiadtes-files',
      filesReadOnly: 'web:candidates-files:read-only',
    },
  },
};
